var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "#57454A",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2203 0.193555C11.7285 0.0373699 12.2718 0.0373696 12.78 0.193555L16.761 1.41711C18.8378 2.05544 20.8102 2.99392 22.6156 4.20279C24.0198 5.14305 23.3542 7.33337 21.6643 7.33337H2.33604C0.646105 7.33337 -0.0194924 5.14305 1.38471 4.2028C3.19009 2.99392 5.16248 2.05544 7.23933 1.41711L11.2203 0.193555ZM12.1924 2.1053C12.0671 2.06679 11.9332 2.06679 11.8079 2.1053L7.82691 3.32886C6.2525 3.81275 4.74404 4.48614 3.33442 5.33337H20.6659C19.2563 4.48614 17.7478 3.81275 16.1734 3.32885L12.1924 2.1053Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 25C1.66683 24.4478 2.11454 24 2.66683 24H21.3335C21.8858 24 22.3335 24.4478 22.3335 25C22.3335 25.5523 21.8858 26 21.3335 26H2.66683C2.11454 26 1.66683 25.5523 1.66683 25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 19.6667C4.3335 20.219 4.78121 20.6667 5.3335 20.6667C5.88578 20.6667 6.3335 20.219 6.3335 19.6667L6.3335 11.6667C6.3335 11.1144 5.88578 10.6667 5.3335 10.6667C4.78121 10.6667 4.3335 11.1144 4.3335 11.6667L4.3335 19.6667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 20.6667C11.4479 20.6667 11.0002 20.219 11.0002 19.6667L11.0002 11.6667C11.0002 11.1144 11.4479 10.6667 12.0002 10.6667C12.5524 10.6667 13.0002 11.1144 13.0002 11.6667V19.6667C13.0002 20.219 12.5524 20.6667 12.0002 20.6667Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6668 19.6667C17.6668 20.219 18.1145 20.6667 18.6668 20.6667C19.2191 20.6667 19.6668 20.219 19.6668 19.6667V11.6667C19.6668 11.1144 19.2191 10.6667 18.6668 10.6667C18.1145 10.6667 17.6668 11.1144 17.6668 11.6667V19.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealization);
export default __webpack_public_path__ + "static/media/realization.8cf6393abf6540aeaf3f4eb23abbc417.svg";
export { ForwardRef as ReactComponent };